export default __webpack_public_path__ + "static/media/project-in-progress-status.12376ed1.svg";